import { VendorConsignmentRentalPeriodListPage } from "@/features/vendor-consignment-rental-period/pages/VendorConsignmentRentalPeriodListPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/vendor-consignment-rental-period/")({
	beforeLoad({ context }) {
		if (
			!context.authAdapter.can({
				permissions: ["vendor_consignment.view"],
			})
		) {
			throw redirect({ to: "/403" });
		}
	},
	component: VendorConsignmentRentalPeriodListPage,
});
